import { render, staticRenderFns } from "./MyPage.vue?vue&type=template&id=000d6de8&scoped=true&"
import script from "./MyPage.vue?vue&type=script&lang=js&"
export * from "./MyPage.vue?vue&type=script&lang=js&"
import style0 from "./MyPage.vue?vue&type=style&index=0&id=000d6de8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000d6de8",
  null
  
)

export default component.exports